var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "19", height: "12", viewBox: "0 0 19 12", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { id: "Symbols", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        { id: "Read-Receipt-condenced-CTA", transform: "translate(-44 -15)", fill: "#FFF", fillRule: "nonzero" },
        React.createElement(
          "g",
          { id: "Read-Receipt-CTA-button" },
          React.createElement(
            "g",
            { id: "Group", transform: "translate(44)" },
            React.createElement(
              "g",
              { id: "Read-Receipts-/-read-/-white", transform: "translate(0 12)" },
              React.createElement("path", { d: "M18.55 3.843a1.209 1.209 0 0 0-1.653.19L10.67 11.65l-1.656-1.406 3.933-4.81a1.104 1.104 0 0 0-.198-1.591 1.209 1.209 0 0 0-1.653.19L4.867 11.65 1.99 9.009a1.21 1.21 0 0 0-1.664.037 1.103 1.103 0 0 0 .038 1.602l3.707 3.403a1.343 1.343 0 0 0 .999.346c.368-.025.71-.2.937-.479l1.542-1.885 2.324 2.018a1.343 1.343 0 0 0 1 .346c.367-.025.709-.2.936-.479l6.939-8.485a1.104 1.104 0 0 0-.197-1.59z", id: "double-check-blue" })
            )
          )
        )
      )
    )
  );
});


// WEBPACK FOOTER //
// ./src/shared/components/svgs/read_receipt.svg